import React from "react";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { FormControl } from "@material-ui/core";
import useStyles from "../styles";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 600,
      minWidth: 230,
      maxWidth: "fit-content",
      position: "relative",
      right: 0,
    },
  },
};
export const SelectWidget = ({
  id,
  name,
  size,
  onChange,
  variant,
  classname,
  value,
  error,
  fullWidth,
  ammend,
  options,
  disabled,
  selectOption,
  isPrinciple,
  defaultValueDisabled=false,
  isPayment,
  defaultValue,
  options2,
  ...props
}) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <FormControl
        className={error ? classes.defaultError : classes.defaultSelect}
      >
        <Select
          classes={{
            root: disabled ? classes.disabledInput : classes.editableInput,
          }}
          fullWidth={fullWidth}
          id={id}
          name={name}
          size={size}
          onChange={onChange}
          className={classes.selectEmpty}
          value={value}
          title={value}
          defaultValue={defaultValue}
          MenuProps={MenuProps}
          disabled={disabled}
          error={error}
        >
          <MenuItem
            value={selectOption ? selectOption : ""}
            className={classes.menuItem}
            disabled={defaultValueDisabled}
          >
            {selectOption ? selectOption : "Select"}
          </MenuItem>
          {options2
            ? options2.map((item, index) => (
                <MenuItem className={classes.menuItem} key={index} value={item}>
                  {item}
                </MenuItem>
              ))
            : options.map((item, index) => (
                <MenuItem
                  className={classes.menuItem}
                  key={index}
                  value={item.value}
                >
                  {item.name}
                </MenuItem>
              ))}
        </Select>
      </FormControl>
    </React.Fragment>
  );
};
SelectWidget.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};
